import { DetectionMethod } from '@/constants/enum';
import { useUpdateLanguageSettingsMutation } from '@/redux/api/api.caller';
import { ChoiceList, Modal } from '@shopify/polaris';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { handleMutationResult } from '../../toastResult';

interface Props {
  open: boolean;
  onClose: () => void;
  current: DetectionMethod;
}

const CHOICES = [
  { label: 'Shop locale', value: DetectionMethod.ShopLocale, helpText: "Use the store's primary language." },
  { label: 'Shopify Markets', value: DetectionMethod.ShopifyMarkets, helpText: "Resolve from the visitor's market/country." },
  { label: 'Visitor IP / geolocation', value: DetectionMethod.Ip, helpText: "Detect from the visitor's IP location." },
  {
    label: 'URL parameter',
    value: DetectionMethod.Url,
    helpText: 'Read the language from the ?lang= query in the URL, set to an ISO language code (e.g. ?lang=fr, ?lang=zh-CN).',
  },
  { label: 'Browser language', value: DetectionMethod.Browser, helpText: "Use the browser's preferred language." },
];

const DetectionMethodModal = ({ open, onClose, current }: Props) => {
  const dispatch = useDispatch();
  const [updateSettings, { isLoading }] = useUpdateLanguageSettingsMutation();
  const [selected, setSelected] = useState<DetectionMethod>(current);

  useEffect(() => {
    if (open) setSelected(current);
  }, [open, current]);

  const onSubmit = () => {
    updateSettings({ detectionMethod: selected }).then((res: any) => {
      if (handleMutationResult(dispatch, res)) onClose();
    });
  };

  return (
    <Modal
      open={open}
      title="Language detection method"
      onClose={onClose}
      primaryAction={{ content: 'Save', onAction: onSubmit, loading: isLoading }}
      secondaryActions={[{ content: 'Cancel', onAction: onClose }]}
    >
      <Modal.Section>
        <ChoiceList
          title="Detection method"
          titleHidden
          choices={CHOICES}
          selected={[selected]}
          onChange={(value) => setSelected(value[0] as DetectionMethod)}
        />
      </Modal.Section>
    </Modal>
  );
};

export default DetectionMethodModal;
